import React, { useState } from "react";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import CustomTextInput from "../../../../components/CustomTextInput";
import Tooltip from "@material-ui/core/Tooltip";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import Color from "../../../../../utils/Color";
import CustomButton from "../../../../components/CustomButton";
import HelpIcon from "@material-ui/icons/Help";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Button from "@material-ui/core/Button";
import AuthManager from "../../../../../utils/AuthManager";
import Image from "../../../../../assets";
import { IconButton } from "@material-ui/core";
import { VisibilityOffOutlined, VisibilityOutlined } from "@material-ui/icons";

const StyledTooltip = withStyles({
  tooltip: {
    color: "#8b8b8b",
    backgroundColor: "#FFEDB9",
    ...getFontWeight("normal"),
    ...getFontSize("small"),
    maxWidth: "500px",
    paddingLeft: 14,

    //maxHeight:"none"
  },
})(Tooltip);

const BlueOnGreenTooltip = withStyles({
  tooltip: {
    color: "#74788D",
    backgroundColor: "#FFEDB9",
    minWidth: "400px",
  },
  arrow: {
    fontSize: 25,
    width: "20px",
    color: "#FFEDB9",
    "&::before": {
      backgroundColor: "#FFEDB9",
      //border: "2px solid red"
    },
  },
})(Tooltip);

const BlueOnGreenTooltip2 = withStyles({
  tooltip: {
    color: "#74788D",
    backgroundColor: "#FFEDB9",
    //minWidth: "400px",
  },
})(Tooltip);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  tooltipContainer: {
    display: "flex",
  },
  infoIconStyle: {
    width: "20x",
    height: "20px",
    color: "#00B4AF",
    marginLeft: 10,
  },
  infoIconStyleV2: {
    width: "20x",
    height: "20px",
    color: "#FEC31A",
    marginLeft: 10,
  },
  tooltipTextStyle: {
    color: "#74788D",
    //opacity: 0.45,
    fontSize: "12px",
    fontWeight: "400",
    padding: 2,
    lineHeight: 1.6,
    paddingLeft: 5,
    //background:"red"
  },
  labelTextInputTextStyle: {
    ...getFontWeight("600"),
    ...getFontSize("medium"),
    color: Color.primaryTextColor,
  },
  labelTextInputTextStyleErr:{
    ...getFontWeight("600"),
    ...getFontSize("medium"),
    color: "#EF4444"
  },
  textInputContainer: {
    height: 48,
    marginTop: 5,
  },
  forgotTextStyle: {
    color: "#00B4AF",
    ...getFontSize("small"),
    textAlign: "right",
    marginTop: 10,
  },
  forgotTextStyleV2: {
    color: "#0EA5E9",
    ...getFontSize("small"),
    textAlign: "left",
    marginTop: 5,
    fontSize: '12px',

  },
  forgotTextStyle2: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  loginButtonStyle: {
    width: "100%",
    marginTop: "3%",
    marginBottom: 15,
    height: "56px",
    borderRadius: '4px'
  },
  loginTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  registerNowContainer: {
    display: "flex",
    alignItems: "center",
  },
  highLightedTextStyle: {
    color: "#00B4AF",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  highLightedTextStyleV2: {
    color: "#FEC31A",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  descTextStyle: {
    color: "#818181",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
  },
  tooltip: {
    color: "#8b8b8b",
    backgroundColor: "#FFEDB9",
    ...getFontWeight("normal"),
    ...getFontSize("small"),
    maxWidth: "500px",
    paddingLeft: 14,

    //maxHeight:"none"
  },
  arrow: {
    fontSize: 25,
    width: "20px",
    color: "#FFEDB9",
    "&::before": {
      backgroundColor: "#FFEDB9",
      //border: "2px solid red"
    },
  },
}));

const UserNameLogin = ({
  userID,
  password,
  onChangeUserID,
  onChangePassword,
  enableMaintenance,
  onClickLogin,
  onClickForgotUserID,
  onClickForgotPassword,
  onClickRegisterNow,
  handleKeypress,
  error,
  errorMessage,
  onClickTermOfUse,
  handleMouseDownPassword,
  handleClickShowPassword,
  showPassword
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const getUrlVars = () => {
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  };

  const handleRedirectSingpass = () => {
    var spState = getUrlVars()["SPState"];
    if (spState !== undefined) {
      window.location.href = process.env.REACT_APP_SING_PASS_REDIRECT_URLV2 + `?SPState=${spState}`;
    } else {
      window.location.href = process.env.REACT_APP_SING_PASS_REDIRECT_URLV2;
    }

  };

  const renderTooltip = () => {
    if (!matchesMD) {
      return (
        <BlueOnGreenTooltip
          title={
            <CustomText design={classes.tooltipTextStyle}>
              {<b>Note: </b>}Effective 1st Sep 2019, PDPC Advisory had updated
              NRIC Rules to Enhance Consumer Protection. If you have not logged
              in prior to 1st Sep 2019, your user id is still the same (e.g.
              NRIC/Passport/FIN No.). Upon successful login, you will be
              prompted to set your own personalized User ID.
            </CustomText>
          }
          placement="right"
          arrow
        >
          <HelpIcon className={classes.infoIconStyleV2} />
        </BlueOnGreenTooltip>
      );
    } else {
      return (
        <ClickAwayListener onClickAway={handleTooltipClose}>
          <BlueOnGreenTooltip2
            PopperProps={{
              disablePortal: true,
            }}
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={
              <CustomText design={classes.tooltipTextStyle}>
                {<b>Note: </b>}Effective 1st Sep 2019, PDPC Advisory had updated
                NRIC Rules to Enhance Consumer Protection. If you have not
                logged in prior to 1st Sep 2019, your user id is still the same
                (e.g. NRIC/Passport/FIN No.). Upon successful login, you will be
                prompted to set your own personalized User ID.
              </CustomText>
            }
            // placement={!matchesSM ? "right-start" : "bottom-end"}
            placement={"bottom"}
          >
            <HelpIcon
              className={classes.infoIconStyleV2}
              onClick={handleTooltipOpen}
            />
          </BlueOnGreenTooltip2>
        </ClickAwayListener>
      );
    }
  };

  return (
    <div className={classes.root}>
      <div>
        <div>
          <CustomTextInput
            title={"User ID"}
            textstyle={error ? classes.labelTextInputTextStyleErr:classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth={true}
            value={userID}
            onChange={onChangeUserID}
            tooltip={renderTooltip()}
            error={error}
          />
          <CustomText design={classes.forgotTextStyleV2}>
            <span
              onClick={onClickForgotUserID}
              className={classes.forgotTextStyle2}
            >
              Forgot User ID?
            </span>
          </CustomText>
        </div>
        <div style={{ marginTop: 10, marginBottom: 8 }}>
          <CustomTextInput
            id="outlined-adornment-password"
            type={showPassword ? 'text' : 'password'}
            title={"Password"}
            textstyle={error ? classes.labelTextInputTextStyleErr: classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth={true}
            value={password}
            onChange={onChangePassword}
            onKeyUp={handleKeypress}
            error={error}
            errorMessage={errorMessage}
            endAdornment={(
              <IconButton
                aria-label="toggle password visibility"
                onClick={error ? null:handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {/* errorHint.svg */}
                {error ? <><img src={Image.errorHint}/></> : <>
                  {!showPassword ? <VisibilityOffOutlined style={{ color: '#171717' }} /> : <VisibilityOutlined style={{ color: '#171717' }} />}</>}
              </IconButton>



            )}
          />
          <CustomText
            design={classes.forgotTextStyleV2}
          //onClick={onClickForgotPassword}
          >
            <span
              onClick={onClickForgotPassword}
              className={classes.forgotTextStyle2}
            >
              Forgot Password?
            </span>
          </CustomText>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "flex-end",
          justifyContent: "space-between",
        }}
      >
        {" "}
        <div></div>
        <CustomButton
          title={"Login"}
          design={classes.loginButtonStyle}
          textstyle={classes.loginTextStyle}
          onClick={onClickLogin}
        />{" "}
        {/* <img
          src={Image.singpassBtn}
          style={{ width: 145, height: 36, marginTop: 10, cursor: "pointer" }}
          onClick={handleRedirectSingpass}
          //className={classes.imageStepStyle}
          //style={matchesMD ? { marginTop: 20 } : { marginBottom: 0 }}
        /> */}
      </div>

      {/* <div>
        <CustomText design={classes.descTextStyle} component="div">
          New? Don't have an account?{" "}
          <CustomText
            display={"inline"}
            design={classes.highLightedTextStyleV2}
            onClick={onClickRegisterNow}
          >
            Register Now!
          </CustomText>
        </CustomText>
      </div>

      <div style={{ marginTop: 15 }}>
        <CustomText design={classes.descTextStyle} component="div">
          By logging in, you acknowledge that you have read, understood and
          agreed to our{" "}
          <CustomText
            display={"inline"}
            design={classes.highLightedTextStyleV2}
            onClick={onClickTermOfUse}
          >
            Terms of Use.
          </CustomText>
        </CustomText>
      </div> */}
    </div>
  );
};

export default UserNameLogin;
